import { useMemo } from 'react';
import { EnterpriseState, useEnterprisesProductContext } from '../context/EnterprisesProductContext';
import { useEnterpriseRelationships } from '../queries/ProductForm';

export const useGetDataWithDefaultCurrency = (selectedEnterpriseIds?: string[]) => {
    const {
        state: { enterprises, selectedEnterpriseIds: ids },
    } = useEnterprisesProductContext();

    const { data, isFetching } = useEnterpriseRelationships(selectedEnterpriseIds || ids);

    const enterprisesById = useMemo(
        () =>
            enterprises.reduce(
                (acc, enterprise) => {
                    acc[enterprise.id] = enterprise;
                    return acc;
                },
                {} as Record<string, EnterpriseState>
            ),
        [enterprises]
    );

    const dataWithDefaultCurrency = useMemo(() => {
        if (!data) {
            return [];
        }

        return data.data.map((row) => {
            const enterprise = enterprisesById[row.id];
            return {
                ...row,
                defaultCurrencyCode: enterprise?.defaultCurrencyCode,
            };
        });
    }, [data, enterprisesById]);

    return {
        data: dataWithDefaultCurrency,
        isFetching,
    };
};
